// src/redux/store.js
import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import { rootReducer } from "./reducers/rootReducer";
import { persistStore, persistReducer } from "redux-persist";
import storageLocal from "redux-persist/lib/storage"; // defaults to localStorage

const persistConfig = {
  key: "root",
  storage: storageLocal,
  // blacklist: [
  //   "vendorRegistration",
  //   "vendorKyc",
  //   "getProductReview",
  //   "notifications",
  //   "productDetails",
  // ],
  whitelist: ["auth", "userProfile"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export const persistor = persistStore(store);
